(ns storrito.authentication.return-to
  "Carries the page a logged-out user wanted to open through the login
   flow, e.g. `/ui/subscription?source=trial-ended-email` from an
   onboarding email.

   The client sends it to `/login/` as the `return-to` query param, the
   login page hands it to WorkOS as `state`, and the callback redirects
   there instead of to the agenda."
  (:require [clojure.string :as str]))

(def max-length
  "WorkOS carries `state` verbatim, keep it short."
  512)

(defn safe-return-to
  "Returns `return-to` when it is a relative path on the current host
   (e.g. `/ui/subscription?source=x`), else nil.

   Rejects protocol-relative URLs (`//evil.com`), backslashes,
   whitespace and control characters, so a crafted `return-to` can never
   redirect the user off the tenant host."
  [return-to]
  (when (and (string? return-to)
             (<= 1 (count return-to) max-length)
             (str/starts-with? return-to "/")
             (not (re-find #"^/[/\\]" return-to))
             (not (re-find #"[\s\x00-\x1f\x7f]" return-to)))
    return-to))

(defn- url-encode
  [s]
  #?(:clj (java.net.URLEncoder/encode ^String s "UTF-8")
     :cljs (js/encodeURIComponent s)))

(defn login-url
  "The `/login/` URL that brings the user back to `return-to` after the
   login. Plain `/login/` when `return-to` is missing or unsafe."
  [return-to]
  (if-let [return-to (safe-return-to return-to)]
    (str "/login/?return-to=" (url-encode return-to))
    "/login/"))

(defn workos-state
  "The WorkOS `state` value that carries `return-to` to the callback
   (`parts.workos.callback/add-state-param` reads it back as EDN)."
  [return-to]
  (when-let [return-to (safe-return-to return-to)]
    (pr-str {:return-to return-to})))

(comment
  (safe-return-to "/ui/subscription?source=trial-ended-email")
  (safe-return-to "//evil.com/x")
  (safe-return-to "https://evil.com")
  (login-url "/ui/subscription?source=trial-ended-email")
  (workos-state "/ui/subscription?source=trial-ended-email"))
